import { useEffect, useState } from 'react';
import { TableCollapseCustom } from 'src/app/modules/component/table/table-collapse/TableCollapseCustom';

type Props = {
	data: any[];
	columns: any[];
};

const DanhSachDichVu = ({ data, columns }: Props) => {
	const [tableData, setTableData] = useState<any[]>([]);

	useEffect(() => {
		setTableData(data);
	}, [data]);

	return (
		<div>
			<TableCollapseCustom
				columns={columns}
				data={tableData}
				childrenField="subs"
				className="overflow-auto spaces h-calc-vh-324"
				isFromTabXN
			/>
		</div>
	);
};

export default DanhSachDichVu;
